import { Project } from "../types/create-project";
import { clients } from "../../../lib/https"
import { ConfigurationSettings } from "/models/configuration-settings"


// interface ProjectResponse {
//     Id: string;
//     Name: string;
//     Exttra: Record<string, unknown>;
//     Conversations: any[];
// }

export interface getConversationByProjectIdPayload {
  "projectId": string,
  "pageSize": number,
  "page": number
  "isArchived": boolean,
  "withLastUserMessage"?: boolean
}

export interface ConvertedProjectResponse {
  id: string;
  name: string;
  tenantId: string;
  createdDate: string;  
  createdBy: string;
  lastUpdatedDate: string; 
  prompts?: any[];
  instructions?: string | null;
  color?: string;
}

export interface ProjectResponse {
 data: ConvertedProjectResponse[],
 page: number,
 pageSize: number,
 totalCount: number
}



export interface projectQueryParams {
  page: number,
  pageSize: number,
  order?: string,
  searchQuery?: string
}

export interface fetchProjectFilesPayload {
  projectId: string;
  page: number;
  pageSize: number;
  order?: string;
  searchQuery?: string;
  totalCount?: number;
}

export interface ProjectFileResponse {
  fileId: string;
  fileName: string;
  extension: string;
  createdDate: string;
  lastUpdatedDate: string;
  size: number;
  vectorizationStatus: string;
}

export interface ProjectFilesPaginatedResponse {
  totalCount: number;
  page: number;
  pageSize: number;
  data: ProjectFileResponse[];
}

 export type ApiConversationResponse = {
      tenantId: string;
      conversationId: string;
      conversationTitle: string;
      createdBy: string;
      createdDate: string;
      isArchived: boolean;
      lastUpdatedDate: string;
      participants: object;
      messages: any[];
      events: any[];
      projectId: string | null;
      shareMetadata?: { token: string; permissionType: string; createdBy: string; createdDate: string; expiresAt: string | null }[];
      customGptId?: string;
      agentId?: string;
      agentIds?: string[] | null;
      logo_url?: string | null;
      logoUrl?: string | null;
      color?: string | null;
  };
export interface CreateProjectRequest {
    name: string;
    conversationId?: string;
    color?: string;
}

export interface CreateProjectResponse {
  id: string;
  name: string;
  tenantId: string;
  createdBy: string;
  createdDate: string;
  lastUpdatedDate: string;
  prompts: any[];
  filesCount: number;
  color?: string;
}


export interface UpdateProjectRequest {
   projectId?: string | null;
   conversationId: string;
   conversationTitle?: string,
   isArchived?: boolean,
}
export interface renameProjectRequest {
   projectId: string;
   name: string;
   color?: string;
}



export const createProject = async (configurationSettings: ConfigurationSettings, payload: CreateProjectRequest): Promise<CreateProjectResponse> => {
    const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjectsCreate}`;
    const response = await clients.post(url, configurationSettings.blocksKey, JSON.stringify({
      "name": payload.name,
      ...payload.conversationId && {conversationId: payload.conversationId},
      ...payload.color && {color: payload.color}
    }));
    return response as CreateProjectResponse;
}

export const updateProject = async (configurationSettings: ConfigurationSettings, payload: UpdateProjectRequest) => {

  const Payload: any = { };
  payload.conversationTitle && (Payload["conversationTitle"] = payload.conversationTitle);
   "isArchived" in payload && (Payload["isArchived"] = payload.isArchived);
   "projectId" in payload && (Payload["projectId"] = payload.projectId);
   
    const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.seliseAi.collaborationConversation}/${payload.conversationId}`;
    const response = await clients.put(url, configurationSettings.blocksKey, JSON.stringify(Payload));
    return response;
}

export const renameProject = async (configurationSettings: ConfigurationSettings, payload: renameProjectRequest) => {
    const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjects}/${payload.projectId}`;
    const response = await clients.put(url, configurationSettings.blocksKey, JSON.stringify({
  "name": payload.name,
  ...payload.color && {color: payload.color}
}));
    return response;
}


export const fetchProjectsPage = async (
  queryParams: projectQueryParams,
  configurationSettings: ConfigurationSettings
): Promise<{ projects: Project[]; totalCount: number }> => {
  const payload = {
    page: queryParams.page,
    pageSize: queryParams.pageSize,
    order: queryParams.order,
    searchQuery: queryParams.searchQuery
  }

  const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjects}`;
  const response = await clients.post<ProjectResponse>(url, configurationSettings.blocksKey, JSON.stringify(payload));

  const projects: Project[] = response.data.map((project: ConvertedProjectResponse) => ({
    id: project.id,
    name: project.name,
    items: [],
    color: project.color,
    instructions: project.instructions ?? undefined,
  }));

  return { projects, totalCount: response.totalCount ?? projects.length };
};

export const fetchProjects = async (
  queryParams: projectQueryParams,
  configurationSettings: ConfigurationSettings
): Promise<Project[]> => {
  const { projects } = await fetchProjectsPage(queryParams, configurationSettings);
  return projects;
};


  export const fetchProject = async (
    configurationSettings: ConfigurationSettings,
    projectId: string
  ): Promise<Project> => {
    const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjects}/${projectId}`;
    const response = await clients.get<ConvertedProjectResponse>(url, configurationSettings.blocksKey);
    
    return {
        id: response.id,
        name: response.name,
        items: [],
        instructions: response.instructions ?? '',
        color: response.color,
    };
  };
  

export const deleteProjectById = async (configurationSettings: ConfigurationSettings, projectId: string): Promise<void> => {
    const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjects}/${projectId}`;
    return clients.delete(url, configurationSettings.blocksKey);
}


export const getConversationByProjectId = async (
    payload: getConversationByProjectIdPayload,
    config: ConfigurationSettings
  ): Promise<{ data: ApiConversationResponse[], total_count: number }> => {

      const baseUrl = `${config.paths.seliseAiBaseUrl}`;
      const url = `${baseUrl}${config.paths.seliseAi.collaborationConversation}`;
      return await clients.post<{ data: ApiConversationResponse[], total_count: number }>(
        `${url}`,
        config.blocksKey,
        JSON.stringify(payload)
      );
  };

  export const fetchProjectConversations = async (
  configurationSettings: ConfigurationSettings,
  projectId: string
) => {
  const res = await getConversationByProjectId(
    {
      projectId,
      pageSize: 50,
      page: 1,
      isArchived: false,
      withLastUserMessage: true,
    },
    configurationSettings
  );

  return res.data.map(conv => ({
    ProjectId: conv.projectId || '',
    ConversationId: conv.conversationId,
    ConversationTitle: conv.conversationTitle,
    CreatedBy: conv.createdBy,
    TenantId: conv.tenantId,
    CreatedDate: conv.createdDate,
    LastUpdatedDate: conv.lastUpdatedDate,
    Conversations: conv.messages,
    ShareToken: conv.shareMetadata?.[0]?.token ?? undefined,
  }));
};


export const fetchProjectFiles = async (
  configurationSettings: ConfigurationSettings,
  payload: fetchProjectFilesPayload
): Promise<ProjectFilesPaginatedResponse> => {
  const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjects}/files`;
  
  const body: Record<string, any> = {
    projectId: payload.projectId,
    page: payload.page,
    pageSize: payload.pageSize,
  };
  
  if (payload.order) {
    body.order = payload.order;
  }
  
  if (payload.searchQuery) {
    body.searchQuery = payload.searchQuery;
  }
  
  return clients.post<ProjectFilesPaginatedResponse>(url, configurationSettings.blocksKey, JSON.stringify(body));
}

export const addFilesToProject = async (configurationSettings: ConfigurationSettings, projectId: string, file: File) => {
  const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjects}/${projectId}/files/upload`;
  
  const formData = new FormData();
  formData.append('file', file);
  return clients.post<ProjectFileResponse>(url, configurationSettings.blocksKey, formData, {}, true);
}


export const deleteFileFromProject = async (configurationSettings: ConfigurationSettings, projectId: string, fileIds: string[]) => {
  const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjects}/files/delete`;
  const payload = {
    projectId,
    fileIds
  };
  return clients.post(url, configurationSettings.blocksKey, JSON.stringify(payload));
}

export const addInstructionToProject = async (configurationSettings: ConfigurationSettings, projectId: string, instruction: string): Promise<ConvertedProjectResponse> => {
  const baseUrl = `${configurationSettings.paths.seliseAiBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.seliseAi.conversationProjects}/${projectId}`;
  return clients.put<ConvertedProjectResponse>(url, configurationSettings.blocksKey, JSON.stringify({ instructions: instruction }));
}